import { CancelButton, EditButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { TextLabel } from '@core/components/Inputs';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { formatPercentual } from '@format';
import { Grid } from '@material-ui/core';
import React from 'react';
import { FaCalendarCheck } from 'react-icons/fa';
import { ImpostoAction } from '../../store/impostoAction';
import { useImposto } from '../../store/impostoContext';

function ImpostoVisualizacaoModal() {
  const [state, dispatch] = useImposto();

  const handleCancelar = () => dispatch(ImpostoAction.fecharModalVisualizacao());
  const handleEditar = () => dispatch(ImpostoAction.setEditarRegistro(state.registro));

  const labels = {
    OUTROS: 'Outros impostos',
    IBSCBS: 'Guia Nacional IBS/CBS',
  };

  return (
    <SimpleDialog open={state.visualizar} onClose={handleCancelar}>
      <SimpleDialogContent
        header={{
          title: 'Cadastro de imposto',
          icon: <FaCalendarCheck />,
          toolbar: (
            <>
              <CancelButton onClick={handleCancelar}>Fechar</CancelButton>
              {permissaoUtils.imposto().editar && <EditButton onClick={handleEditar}>Editar</EditButton>}
            </>
          ),
        }}
        content={
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <TextLabel label="Nome do Imposto" id="nome" value={state?.registro?.nome} />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <TextLabel
                label="Fornecedor"
                id="fornecedor.pessoa.nome"
                value={state?.registro?.fornecedor?.pessoa?.nome}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <TextLabel label="Código do imposto" id="codigo" value={state?.registro?.codigo} />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <TextLabel
                label="Alíquota (%)"
                id="aliquota"
                value={state?.registro?.aliquota}
                format={formatPercentual}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <TextLabel
                label="Tipo do imposto"
                id="tipo"
                value={state?.registro?.tipo}
                format={(value) => labels[value.toUpperCase()] ?? value}
              />
            </Grid>
          </Grid>
        }
      />
    </SimpleDialog>
  );
}

export default ImpostoVisualizacaoModal;
